export default __webpack_public_path__ + "static/media/conventional.45687957.jpg";